module.exports = __webpack_public_path__ + "03b4b826440b176acbb0910224473a5f.png";